export const STOCK_TRANSFER = "STOCK_TRANSFER";
export const STOCK_TRANSFER_SUCCESS = "STOCK_TRANSFER_SUCCESS";
export const STOCK_TRANSFER_FAILED = "STOCK_TRANSFER_FAILED";

export const GET_ALL_REJECT_STORE_ITEMS = "GET_ALL_REJECT_STORE_ITEMS";
export const GET_ALL_REJECT_STORE_ITEMS_SUCCESS = "GET_ALL_REJECT_STORE_ITEMS_SUCCESS";
export const GET_ALL_REJECT_STORE_ITEMS_FAILED = "GET_ALL_REJECT_STORE_ITEMS_FAILED";